export default {
  title: '行政区划',

  // 标签页
  tabs: {
    first: '一级行政区划',
    second: '二级行政区划',
    third: '三级行政区划',
    fourth: '四级行政区划',
    fifth: '五级行政区划'
  },

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '区划代码、区划名称',
    status: '状态',
    statusPlaceholder: '请选择状态',
    enabled: '启用',
    disabled: '禁用',
    country: '国家',
    countryPlaceholder: '选择国家',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    add: '新增{level}',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    name: '名称',
    nameEn: '英文名称',
    code: '编码',
    country: '国家',
    category: '类型',
    status: '状态',
    operation: '操作',
    noData: '-'
  },

  // 级别名称
  levels: {
    first: '一级行政区划',
    second: '二级行政区划',
    third: '三级行政区划',
    fourth: '四级行政区划',
    fifth: '五级行政区划'
  },

  // 父级名称
  parentNames: {
    first: '国家',
    second: '所属一级行政区划',
    third: '所属二级行政区划',
    fourth: '所属三级行政区划',
    fifth: '所属四级行政区划'
  },

  // 选择弹窗
  modal: {
    title: '选择{level}',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 个{level}',
    selectedStatus: '已选择 {count} 个{level}，共 {total} 个可选',
    selectCountry: '选择国家',
    selectFirstLevel: '选择一级行政区划',
    selectSecondLevel: '选择二级行政区划',
    selectThirdLevel: '选择三级行政区划',
    selectFourthLevel: '选择四级行政区划',
    selectParent: '请选择',
    belongToFirstLevel: '所属一级行政区划',
    belongToSecondLevel: '所属二级行政区划',
    belongToThirdLevel: '所属三级行政区划',
    belongToFourthLevel: '所属四级行政区划'
  },

  // 确认对话框
  confirm: {
    enable: '确定要启用此行政区划吗？',
    disable: '确定要禁用此行政区划吗？',
    batchEnable: '确定要启用选中的 {count} 个行政区划吗？',
    batchDisable: '确定要禁用选中的 {count} 个行政区划吗？'
  },

  // 表单验证
  validation: {
    selectItems: '请选择要添加的{level}'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的行政区划',
    selectToDisable: '请选择要禁用的行政区划',
    selectToAdd: '请选择要添加的{level}',
    loadError: '数据加载失败，请稍后重试',
    countryLoadError: '国家数据加载失败',
    parentLoadError: '上级行政区划数据加载失败',
    statusUpdateSuccess: '行政区划状态更新成功',
    statusUpdateError: '状态更新失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 个行政区划',
    batchEnableError: '批量启用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 个行政区划',
    batchDisableError: '批量禁用失败，请稍后重试',
    associateSuccess: '成功关联 {count} 个{level}',
    associateError: '关联失败，请稍后重试'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  }
}
